import { apiGet, apiPost } from './apiClient';

export interface NewsletterSubscriber {
  id: string;
  email: string;
  created_at: string;
  is_active: boolean;
}

export const newsletterService = {
  // Подписать пользователя на новости
  async subscribe(email: string): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiPost<{ success: boolean; message: string }>(
        '/newsletter/subscribe',
        { email },
        false
      );
      return response || { success: false, message: 'Что-то пошло не так, попробуйте еще раз' };
    } catch (error) {
      console.error('Ошибка при подписке:', error);
      return {
        success: false,
        message: 'Что-то пошло не так, попробуйте еще раз'
      };
    }
  },

  // Получить всех активных подписчиков (для админки)
  async getActiveSubscribers(): Promise<NewsletterSubscriber[]> {
    const payload = await apiGet<{ data: NewsletterSubscriber[] }>('/newsletter/active');
    return payload?.data || [];
  }
}; 